import { useAction, useAtom } from '@reatom/npm-react'

import { useHapticFeedback } from '@blade/ui-kit'
import { useAppRoutes } from '@root/features/routing'
import { FollowUserButton } from '@root/features/user/activity-actions'
import { ActivityKebabActions } from '@root/features/user/activity-actions/activity-kebab-actions'
import {
  relationDrawerDelugeIdAtom,
  relationTabAtom,
  userProfileTabAtom,
} from '@root/features/user/profile-header/atoms'
import { UserConnectionsShortItem } from '@root/features/user/user-connections/ui/user-connections-item/user-connections-short-item'

import { relationViewEvent } from '../atoms'

import type { SearchUser } from '@root/entities/search-user'

interface RelationFollowingProps {
  follower: SearchUser.SearchUser & { deployedTokensCount: number | undefined }
}

export const RelationFollowing = ({ follower }: RelationFollowingProps) => {
  const haptics = useHapticFeedback()
  const { navigateUserProfile } = useAppRoutes()
  const relationView = useAction(relationViewEvent)

  const [_relationTab, setRelationTab] = useAtom(relationTabAtom)
  const [_relationDrawer, setRelationDrawerDelugeId] = useAtom(
    relationDrawerDelugeIdAtom,
  )
  const [_userProfileTab, setUserProfileTab] = useAtom(userProfileTabAtom)

  const handleNavigateToUserProfile = () => {
    relationView()
    navigateUserProfile(follower.delugeId)
  }

  return (
    <UserConnectionsShortItem
      withFollowings
      followerDetail={follower}
      onNavigateToUserProfile={() => {
        handleNavigateToUserProfile()
      }}
      onNavigateToFollowers={() => {
        setRelationTab('followers')
        setRelationDrawerDelugeId(follower.delugeId)
      }}
      onNavigateToFollowings={() => {
        setRelationTab('followings')
        setRelationDrawerDelugeId(follower.delugeId)
      }}
      onNavigateToCoins={() => {
        relationView()
        haptics.impactOccurred('light')
        setUserProfileTab('coins')
      }}
    >
      <FollowUserButton
        delugeId={follower.delugeId}
        variant="soft"
        size="xxs"
        radius="rounded"
        type="button"
      />
      <ActivityKebabActions
        onNavigateToUserProfile={handleNavigateToUserProfile}
        userShort={follower}
        size="xxs"
      />
    </UserConnectionsShortItem>
  )
}

RelationFollowing.Skeleton = UserConnectionsShortItem.Skeleton
